module.exports = __webpack_public_path__ + "legal/classroomteacherform.86f91f24.pdf";